import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getCreditUsageData, getOwnChildBranches, getReportBranchList } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo } from '../../../store/common/common_action'
import TableViewCreditUsage from './TableViewCreditUsage'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../common/api'
import { urls } from '../../common/constants'
const CreditUsageReport = (props) => {
  const {
    data: { common, reports },
    getOwnChildBranches,
    getCreditUsageData,
  } = props
  const { ownChildBranches1, reportBranchList, creditUsageReportData } = reports
  const { loginData, citywiseBranchList, roleRights } = common
  const reportName = 'Credit Limit Usage'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [resetCity, setResetCity] = useState(false)
  const [filterSourceCityList, setFilterSourceCityList] = useState([])


  useEffect(() => {
    focusElemnt(disableBtn ? id.creditUsageSplitButton : id.stateId)
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
      setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights)) {
      if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: 0,
          intIsActive: 1,
        }
        PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60 * 1000).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...filteredList]);
            //setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table])
          }
        })
      } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
        const obj = {
          CompanyID: loginData?.intCompanyID,
          CityID: loginData?.intCityID,
          UserID: loginData?.intUserID,
          BranchID: loginData?.intBranchID,
          Mode: 1,
        }
        GetRequest(urls.getReportBranchList, obj).then((res) => {
          if (res.status == 'Success') {
            setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table])
          }
        })
        // getReportBranchList(obj)
        // setSourceBranchList(reportBranchList)
      } else {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: loginData?.intCityID,
          intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...filteredList]);
            //setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table])
          }
        })
      }
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      //setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(ownChildBranches1)) {
      if (ownChildBranches1?.length > 0) {
        let data = []
        let data1 = []
        ownChildBranches1?.map((val, i) => {
          data.push({ StateID: val?.StateID, StateName: val?.StateName })
          data1.push({ CityName: val?.CityName, CityID: val?.CityID, StateID: val?.StateID })
        })
        setStateList([{ StateName: 'All', StateID: 0 }, ...data])
        setSourceCityList([{ CityName: 'All', CityID: 0 }, ...data1])
        // //filter cityList for city
        // setFilterSourceCityList([{ CityName: 'All', CityID: 0 }, ...data1])
        // setStateList(data)
        // setSourceCityList(data1)
        //filter cityList for city
        setFilterSourceCityList(data1)
        //deafultValue
        setSelState({
          StateName: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateName,
          StateID: ownChildBranches1.filter((obj) => obj.CityID === loginData?.intBranchCityID)[0]?.StateID,
        })
        setSelSourceCity({ CityName: loginData?.strCityName, CityID: loginData?.intBranchCityID })
      } else {
        setStateList([])
        setSourceCityList([])
        setSelState('')
        setSelSourceCity('')
      }
    }
  }, [ownChildBranches1])
  const handleClick1 = () => {
    setIsExpanded(true)
    const obj = {
      CompanyID: loginData?.intCompanyID,
      UserID: loginData?.intUserID,
      BranchID: selSourceBranch?.BranchID,
      CityID: selSourceCity?.CityID,
      StateID: selState?.StateID,
    }
    getCreditUsageData(obj)
  }
  const handleClick2 = () => {
    let url = URL.creditUsageReport
    const urlData = URL.creditUsageReportParams
    urlData.chk = loginData.BusCrsCheckSum
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const handleStateChange = (stateId) => {
    if (stateId !== 0) {
      // setResetCity(true)
      setSelSourceCity({ CityName: 'All', CityID: 0 })
      const filteredCities = sourceCityList.filter((val) => val.StateID === stateId || stateId === 0 || val.CityID === 0)
      setFilterSourceCityList(filteredCities)
      setSelSourceCity(filteredCities?.[0] || ' ')
      // const filteredBranch =(removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((val) => val.CityID === filteredCities?.[0]?.CityID || filteredCities?.[0]?.CityID === 0 || val.BranchID === 0)?.[0])

      // setSelSourceBranch(filteredBranch?.[0] || ' ')
      // setSourceBranchList([])
    } else {
      setFilterSourceCityList(sourceCityList)
      setSelSourceCity(sourceCityList?.[0] || ' ')
    }
  }

  const selectedSourceCity = (obj) => {
    setIsExpanded(false)
    setSelSourceCity(obj)
    // setSourceBranch(removeDuplicatesFromArray(sourceBranchData,"SourceBranchID").filter((val) => val.SourceCityID === obj?.SourceCityID || obj?.SourceCityID === 0 || val.SourceBranchID === 0)?.[0]) 
    setSelSourceBranch(removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter((item) => item.CityID === obj?.CityID || obj?.CityID === 0 || item.BranchID === 0)?.[0])
  }

  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompany}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="250px"
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              // data={stateList || []}
              data={removeDuplicatesFromArray(stateList, 'StateID') || []}
              defaultvalue={selState?.StateName}
              idKey={`StateID`}
              dataKey={`StateName`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                setResetCity(true)
                handleStateChange(val.StateID)
              }}
              isObjArr={true}
              //searchPlaceholder={`Search By Report Type`}
              width="200px"
              nextId={id.srcCity}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Source City'}
              // data={getCityList()}
              data={removeDuplicatesFromArray(filterSourceCityList, 'CityID') || []}
              defaultvalue={selSourceCity?.CityName || selSourceCity}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                setIsExpanded(false)
                // setSelSourceCity(val)
                selectedSourceCity(val)
                setResetCity(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="230px"
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetFlag || resetCity}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Source Branch'}
              data={removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                (val) => val.CityID === selSourceCity?.CityID || selSourceCity?.CityID === 0 || val.BranchID === 0
              ) || []}
              defaultvalue={selSourceBranch?.BranchName || selSourceBranch}
              idKey={`BranchID`}
              dataKey={`BranchName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceBranch(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="300px"
              nextId={id.creditUsageSplitButton}
              prevId={id.srcCity}
              resetFlag={resetFlag || resetCity}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) =>
              navigation3(e, isExpanded ? 'creditUsageExcelBtn' : disableBtn ? id.creditUsageSplitButton : id.stateId, () => handleClick1())
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={false}
              id1={id.creditUsageSplitButton}
              prevID={disableBtn ? id.creditUsageSplitButton : id.srcBranch}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          <TableViewCreditUsage
            apiData={creditUsageReportData}
            loginData={loginData}
            fromDate={fromDate}
            toDate={toDate}
            company={loginData?.strCompanyName}
            StateName={selState?.StateName}
            city={selSourceCity?.CityName}
            branch={selSourceBranch?.BranchName}
            disableBtn={disableBtn}
          />
        ) : (
          ''
        )}
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getOwnChildBranches,
  getBranchConfigOrEwbillinfo,
  getReportBranchList,
  getCreditUsageData,
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditUsageReport)
